import { apiConfig } from "../helpers";
import { authHeader } from '../helpers';
import axios from 'axios';

export const notificationService = {
    getUnread,
    markAsRead
};

function getUnread() {
    return axios.get('/api/services/app/AdminNotification/GetUnreadNotifications', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader()
    })
}

function markAsRead(notificationId) {
    return axios.post('/api/services/app/AdminNotification/MarkAsRead', null, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            notificationId: notificationId
        }
    })
}
